export default __webpack_public_path__ + "static/char-v-14-53002127dc0b1ad6311eacc667cdc7ba.png";